// Peças de moldura sem domínio, partilhadas pelo site e pelo backoffice.
import type { ComponentProps, ReactNode } from "react";
import { cn } from "./cn";

export function Container({ className, ...props }: ComponentProps<"div">) {
  return <div className={cn("mx-auto w-full max-w-7xl px-4 sm:px-6", className)} {...props} />;
}

export function PageHeader({
  title,
  description,
  actions,
  className,
}: {
  title: ReactNode;
  description?: ReactNode;
  actions?: ReactNode;
  className?: string;
}) {
  return (
    <div className={cn("mb-6 flex flex-wrap items-end justify-between gap-4", className)}>
      <div>
        <h1 className="text-2xl font-extrabold text-gold sm:text-3xl">{title}</h1>
        {description && <p className="mt-1 text-sm text-muted-foreground">{description}</p>}
      </div>
      {actions && <div className="flex gap-2">{actions}</div>}
    </div>
  );
}

export function EmptyState({ icon, title, children, className }: { icon?: ReactNode; title: ReactNode; children?: ReactNode; className?: string }) {
  return (
    <div className={cn("flex flex-col items-center gap-2 rounded-lg border border-dashed p-10 text-center", className)}>
      {icon && <div className="text-gold [&_svg]:size-8">{icon}</div>}
      <p className="font-title font-semibold">{title}</p>
      {children && <div className="text-sm text-muted-foreground">{children}</div>}
    </div>
  );
}

/** Estado de um serviço: ponto colorido + texto (null = a verificar). */
export function StatusDot({ ok, children }: { ok: boolean | null; children: ReactNode }) {
  return (
    <span className="inline-flex items-center gap-2 text-sm">
      <span className={cn("size-2.5 rounded-full", ok === null ? "animate-pulse bg-muted-foreground" : ok ? "bg-success" : "bg-destructive")} />
      {children}
    </span>
  );
}
